module.exports = __webpack_public_path__ + "assets/img/shouye_canyinyuding-xuanzhong.f4f560bf.svg";